<ng-progress></ng-progress>

<ng-container *ngIf="maintenanceFlag == 0; else checkMaintenance">
    <router-outlet></router-outlet>
</ng-container>

<ng-template #checkMaintenance>
    <ng-container *ngIf="maintenanceFlag == 2; else maintenanceFlagElse">

    </ng-container>
</ng-template>

<ng-template #maintenanceFlagElse>
    <app-coming-soon></app-coming-soon>
</ng-template>


